import React from 'react';
import './SecurityResources.css';

const primaryResource = {
    imgSrc: "https://sendbird.imgix.net/cms/Sendbird-security-detection.webp?auto=format,compress&crop=faces",
    category: "Blog",
    title: "Sendbird’s risk-aware detection & response program",
    description: "Learn how the Sendbird security team built a risk-based automation framework to enhance detection and response actions.",
    link: "#"
};

const secondaryResources = [
    {
        imgSrc: "https://sendbird.imgix.net/cms/IT-onboarding_Sendbird-2xrs.webp?auto=format,compress&crop=faces",
        category: "Blog",
        title: "Revolutionizing IT onboarding: A zero-touch approach",
        link: "#"
    },
    {
        imgSrc: "https://sendbird.imgix.net/cms/AWS-security-at-Sendbird.png?auto=format,compress&crop=faces",
        category: "Blog",
        title: "How does Sendbird secure AWS?",
        link: "#"
    },
    {
        imgSrc: "https://sendbird.imgix.net/cms/스크린샷-2025-03-25-오전-10.11.08-1.png?auto=format,compress&crop=faces",
        category: "YOUTUBE",
        title: "Multi-layered Zero Trust with Yash Kosaraju",
        link: "#"
    }
];

const ResourceCard = ({ resource, type }) => (
    <a href="#" className={`security-resource-card-item type-${type}`}>
        <div className="security-resource-card-image-container">
            <img src={resource.imgSrc} alt={resource.title} loading="lazy" />
        </div>
        <div className="security-resource-card-content">
            <span className="security-resource-card-category">{resource.category}</span>
            <h5 className="security-resource-card-title">{resource.title}</h5>
            {resource.description && 
                <p className="security-resource-card-description">{resource.description}</p>
            }
        </div>
    </a>
);

function SecurityResources() {
  return (
    <section className="security-resources-wrapper">
      <div className="security-resources-container">
        <div className="security-resources-intro">
            <h3 className="security-resources-headline">Security resources and insights</h3>
            <p className="security-resources-subheadline">
                Sendbird actively contributes to the global security community - sharing insights on emerging threats, AI safety, and best practices through blog posts, podcasts, and industry events.
            </p>
            <a href="#" role="link" className="security-resources-link">
                Visit our resource page
            </a>
        </div>
        
        <div className="security-resources-grid">
            <div className="security-resources-primary-col">
                <ResourceCard resource={primaryResource} type="primary" />
            </div>
            <div className="security-resources-secondary-col">
                {secondaryResources.map((res, index) => (
                    <ResourceCard key={index} resource={res} type="secondary" />
                ))}
            </div>
        </div>
      </div>
    </section>
  );
}

export default SecurityResources;